import { z } from 'zod'
import { ReactNode } from 'react'
import { UseQueryOptions } from '@tanstack/react-query'

const ApiErrorBodySchema = z.object({
  code: z.number(),
  message: z.string(),
  details: z.record(z.unknown()).nullable(),
})
export type RequestError = z.infer<typeof ApiErrorBodySchema>

const ApiErrorSchema = z.object({
  error: ApiErrorBodySchema,
})

export type APIError = z.infer<typeof ApiErrorSchema>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const instanceOfError = (object: any): object is APIError => {
  const result = ApiErrorSchema.safeParse(object)
  return result.success
}

export type RequestStatus = 'idle' | 'in_flight' | 'done'

export type PageDetailsType = {
  path: string
  title: string
  description: string
}

export type ChildrenProp = { children: ReactNode }

export type NoContent = null

export type RequestResponse<T> =
  | {
      error: null
      data: T
    }
  | {
      error: RequestError
      data: null
    }

export interface UserModel {
  id: number
  username?: string
  password?: string | undefined
  email?: string
  first_name?: string
  last_name?: string
  fullname?: string
}

export type Program = {
  status: number
  id: number
  global_state_id: string
  name: string
  state_code?: string
  enrollment_status: number | null
  enrolled_scholar_count: number | null
  program_start_date: undefined | null | Date
  program_end_date: undefined | null | Date
  enrolled_applicants_count: number | null
  enrolled_completed_applicants_count: number | null
  enrolled_rejected_applicants_count: number | null
  global_timezone_code: string | null
}

export type GlobalProgram = {
  status: number
  id: number
  name: string
  domain: string
  global_state_id: string
  manage: number
}

export type SchoolYearOption = {
  id: number
  school_year: string
}

export interface RegisterState {
  email: string
  id: number
  token: string
}

export type Role = {
  id: number
  program_id: number
  code: string
  name: string
  description: string
}

//https://tkdodo.eu/blog/react-query-and-type-script#the-four-generics
export type CustomQueryOptions<
  QueryFuncReturnData,
  SelectData = QueryFuncReturnData,
  QueryFuncError = Error,
> = Omit<
  UseQueryOptions<QueryFuncReturnData, QueryFuncError, SelectData>,
  'queryKey' | 'queryFn' | 'initialData'
>
